import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";
import markup from "ulysses/widgets/details.html";
import "../widgets";

$(document).ready(function() { $(markup).appendTo($("body")); });
function editSettings(current_data) {
    var res = Promise.Deferred();
    var cdata = ko.toJS(current_data);
    var dialog = uly.dialogs.execute($("#details-settings-editor-tmpl").html(), {
        "title":_("details_title_edit_details_properties", "Edit Details Properties")
    }, cdata).done(function([result]) {
        res.resolve({
            "relations":ko.unwrap(result.relations) || null,
            "title": ko.unwrap(result.title) || _("details_editsettings_details", "Details")
        });
    }).fail(res.reject);
    return res.promise();
}

function initDetails() {
    var data = { "relations": "", "title": _("details_title_details", "Details") };
    var def = Promise.Deferred();
    editSettings(data).done(function(result) {
        data.relations = result.relations;
        data.title = result.title;
        def.resolve(data);
    }).fail(def.reject);
    return def;
}


function DetailInfo(detail_data, entity_data) {
    $.extend(this, {
        action:function(e, ui){
            var elt = document.getElementById(ui.model.data.id);
            //TODO: WTF?
            uly.current_grid = ui.model.data._links.self.href;

            var $elt = $(elt);
            $(".details-toolbar .active").removeClass("active");
            $(".table-content .datatable-container").not($elt).addClass("hide");
            if ($elt.data("inited")){
                if (!$elt.is(":visible")){
                    $elt.removeClass("hide");
                    var datatable = $.data(elt, "datatable");
                    datatable.columns.adjust();
                    
                    $(e.currentTarget).parent().addClass("active");
                    datatable.draw();
                }else{
                    $elt.addClass("hide");
                    uly.current_grid = null;
                }
            }else{
                ko.bindingHandlers.datatable.init(elt, ui.model.data, function() { return { dataparameters:{rel:entity_data.id} }; });
                $elt.data("inited", true);
                $elt.removeClass("hide");
                if (e) {
                    $(e.currentTarget).parent().addClass("active");
                }
            }
        },
        data:detail_data
    });
}

ko.bindingHandlers.details = {
    init: function(elt, va, bindings, model, context) {
        var widget_model = ko.unwrap(va());

        var settings = ko.unwrap(widget_model.settings);
        $.each(
            {
                "relations":ko.observable(null),
                "title": ko.observable(_("details_details", "Details"))
            },
            function(key, value) {
                if (typeof settings[key] == "undefined")
                    settings[key] = value;
            }
        );

        var menu = widget_model.settings_menu;
        menu.push({
            "caption":_("details_caption_modify", "Modify"), 
            "icon":"fa-edit", 
            "action":function(e){
                editSettings(settings).done(function(result) {
                    var new_settings = {
                        "relations": ko.unwrap(result.relations),
                        "title": ko.unwrap(result.title) || _("details_details", "Details")
                    };
                    widget_model.settings(new_settings);
                    uly.publish("page.savesettings");
                });
                return false;
            },
            "colour":"primary"
        });

        var entity = ko.unwrap(uly.page.page_resource);
        if (!entity){
            //remove loader and stuff
            return false;
        }
        var data = ko.toJS(entity);
        var hal_entity = HalResource(entity);
        var hal_model = hal_entity.follow("uly:model", {details: "force"});
        data.details = ko.observableArray([]);
        data.widget_title = ko.computed(function() { return ko.unwrap(settings.title) || _("details_details", "Details"); });
        widget_model.title("<h3 class='box-title'>{0}</h3>".format(_("widget_details_loading", "Loading...")));
        widget_model.icon("fa-asterisk");
        hal_model.follow("uly:details").done(function(results){
            var relations = ko.unwrap(ko.unwrap(ko.unwrap(va()).settings).relations);
            if (relations) 
                relations = relations.split(",");

            for (var i = 0; i < results.length; i++){
                var result = results[i];
                //need to only push if the result should be displayed.
                if (result && (!relations || relations.indexOf(result.name) >= 0)) {
                    result.id = uly.utils.get_random();
                    let detail_info = new DetailInfo(result, data);
                    data.details.push(detail_info);
                    if (uly.current_grid == result._links.self.href || results.length == 1 || (relations && relations.length == 1)){
                        detail_info.action(null, { model:detail_info });
                        //$("#action"+result.id).trigger("click");
                    }
                }
            }
        }).always(()=> {
            widget_model.title("<h3 class='box-title'>{0}</h3>".format(data.widget_title()));
        });

        var childContext = context.createChildContext(data);
        ko.applyBindingsToDescendants(childContext, elt);
        uly.publish("widget.active", elt);
        return { controlsDescendantBindings: true };
    }
};

uly.widgets.register({
    "type":"details",
    "caption":_("details_caption_details", "Details"), 
    "description":_("details_description_show_the_details_of_a_record", "Show the details of a record"), 
    "icon":"fa-asterisk", 
    "colour":"default",
    "init": initDetails,
    "actions":[{
        "caption":_("details_caption_settings", "Settings"), 
        "icon":"fa-cog", 
        "action":function(e){
            return false;
        },
        "colour":"default",
        "permission": "editpage"
    }]
});
